import { SystemRole, User, type VtsLog } from "@/models"
import type { VtsLogSummary } from "@/models/vts/VtsLogSummary"
import { Temporal } from "@/Temporal"

export function canEditVtsLog(log: VtsLog | VtsLogSummary | null, loggedInUser: User): boolean {
	if (!log) return false

	const createdAt = "createdAt" in log ? log.createdAt : log.createdBy.timeStamp
	const hoursSinceCreated = Temporal.Now.instant().since(createdAt, { largestUnit: "hours" }).total({ unit: "hours" })

	return (
		loggedInUser.atLeastHasRole(SystemRole.SuperAdmin) ||
		(hoursSinceCreated < 24 && loggedInUser.atLeastHasRole(SystemRole.VTSManager))
	)
}

export function canCreateVtsLog(loggedInUser: User): boolean {
	return loggedInUser.atLeastHasRole(SystemRole.VTSManager)
}
